import React, { useState, useEffect } from 'react';
import http from '../services/httpClient';
import './EmailVerificationScreen.css';

export default function EmailVerificationScreen({ token, onBack, onVerifySuccess }) {
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');
  const [userName, setUserName] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('No verification token provided');
      return;
    }

    const verifyEmail = async () => {
      try {
        const response = await http.post('/auth/verify-email-token', { token });
        setStatus('success');
        setMessage(response.message || 'Email verified successfully!');
        setUserName(response.user?.name || '');
        
        // Auto-redirect after 3 seconds
        setTimeout(() => {
          if (onVerifySuccess) {
            onVerifySuccess(response.user?.email);
          }
        }, 3000);
        
      } catch (error) {
        console.error('❌ Verification failed:', error);
        setStatus('error');
        setMessage(
          error.response?.data?.error || 
          error.response?.data?.details ||
          'Verification failed. Please try again.'
        );
      }
    };

    verifyEmail();
  }, [token, onVerifySuccess]);

  return (
    <div className="verify-email-body">
      <div className="verify-container">
        {status === 'verifying' && (
          <>
            <div className="verify-icon">
              <div className="spinner"></div>
            </div>
            <h1>Verifying Your Email</h1>
            <p className="verify-description">
              Please wait while we verify your email address...
            </p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="verify-icon">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
              </svg>
            </div>
            <h1>Email Verified Successfully</h1>
            {userName && <p className="verify-welcome">Welcome, <strong>{userName}</strong></p>}
            <p className="verify-description">
              Your email address has been successfully verified. Your account is now active and ready to use. You can proceed to login and access your INVEXIS dashboard.
            </p>
            <button 
              className="verify-btn-primary"
              onClick={() => onVerifySuccess && onVerifySuccess()}
            >
              Continue to Dashboard
            </button>
            <p className="verify-footer-text">
              Thank you for verifying your email address. If you need assistance, please contact our support team.
            </p>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="verify-icon error">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
              </svg>
            </div>
            <h1>Verification Failed</h1>
            <p className="verify-description error-message">{message}</p>
            <button 
              className="verify-btn-primary"
              onClick={onBack}
            >
              Back to Login
            </button>
          </>
        )}
      </div>
    </div>
  );
}
